import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OMPLIR_ID_FENOFASE,
  VISUALITZACIO_OMPLIR_ID_ESPECIE
} from "../../actions/actionTypes";

const ESTAT_INICIAL = null;

const idFenofase = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case VISUALITZACIO_OMPLIR_ID_FENOFASE:
      return action.payload;

    case VISUALITZACIO_OMPLIR_ID_ESPECIE:
      return null;

    default:
      return state;
  }
};

export default idFenofase;

export const getIdFenofase = state => state.idFenofase;
